module.exports = __webpack_public_path__ + "img/15---GONNA-BIANCA-U-STAMPE-LINO-RIC.GRECIA-RIC.LIMONE3.044ab0fd.jpg";